function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { styled, css } from 'styled-components';
import { colors } from '../../abstracts/colors';
import { Icon } from '../Icon';
import { a11yBreakpoint } from './variants/DefaultModal/elements';
const ModalDismissButtonElement = styled.button.withConfig({
  componentId: "aui__sc-jq42ld-0"
})(["background-color:transparent;position:absolute;right:1rem;top:1rem;border:0;border-radius:9999px;margin:0;padding:0.5rem;cursor:pointer;transition:background-color 0.2s;&:hover{background-color:", ";}&:active{background-color:", ";}", ""], colors.neutralBrighter, colors.neutralBright, ({
  $actionButtonPresent
}) => $actionButtonPresent && css(["@media only screen and (", "){display:none;}"], a11yBreakpoint));
export const ModalDismissButton = ({
  className = '',
  actionButtonPresent,
  ...rest
}) => /*#__PURE__*/React.createElement(ModalDismissButtonElement, _extends({
  id: `modal-dismiss-button`,
  "aria-label": "close dialog",
  className: className,
  $actionButtonPresent: actionButtonPresent
}, rest), /*#__PURE__*/React.createElement(Icon.SSR, {
  size: "large",
  src: "close-x",
  color: "black"
}));